function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4783 24.6246C11.0529 24.6246 7.60808 29.5386 7.60808 35.489C7.60808 41.4405 11.054 46.3612 15.4783 46.3612C19.9026 46.3612 23.411 41.4405 23.411 35.489C23.4121 29.5386 19.9026 24.6246 15.4783 24.6246ZM28.2258 52.3796L25.496 47.2704C22.7662 50.8948 18.9767 52.3796 14.616 52.3796C6.48695 52.3796 0.13052 45.2635 0 35.489C0 25.7234 6.50145 17.8911 14.6316 17.8911C18.9923 17.8911 22.7662 20.0899 25.496 23.7188L28.2258 18.6028H30.6956V52.3796H28.2258Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7661 52.3797H49.2962L35.2793 18.604H42.9532L50.5624 37.3687L58.1047 18.604H65.783L51.7661 52.3797Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M102.312 2.53342L102.314 2.5245C100.372 0.944875 97.9179 0 95.2684 0C88.9488 0 83.8262 5.10032 83.8262 11.3865C83.8262 13.9433 84.7208 16.2916 86.2257 18.1612C87.6168 18.1456 88.8116 18.4513 89.7196 18.8116C87.3167 17.1639 85.7472 14.4576 85.7472 11.3865C85.7472 6.20695 89.9673 2.00688 95.1736 2.00688C95.9177 2.00688 96.6439 2.09836 97.3389 2.26792C96.1174 3.03542 95.303 4.38636 95.303 5.93252C95.303 8.2618 97.2552 10.1359 99.6581 10.1359C102.003 10.1359 103.955 8.2618 103.955 5.93252C103.955 4.55481 103.303 3.32881 102.312 2.53342Z",
  fill: "#BBD422"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M81.8696 24.7875C79.3239 26.1306 77.3784 28.8626 77.3784 32.1624V52.3796H70.1641V18.604H72.635L75.367 23.5236C77.7699 20.1591 81.5561 18.1745 85.7718 17.8945C89.2456 17.6647 91.6307 19.5444 91.6307 19.5444L88.6789 25.1277C88.6778 25.1266 85.6636 22.7806 81.8696 24.7875Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M103.261 18.5898H96.0391V52.3688H103.261V18.5898Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M121.412 2.04053H114.195V52.3799H121.412V2.04053Z",
  fill: "black"
});

function SvgAvril(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 53,
    viewBox: "0 0 122 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvril);
export default __webpack_public_path__ + "static/media/avril.4d968560.svg";
export { ForwardRef as ReactComponent };